import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TestOption from '../compnents/TestOption';
import FileUploader from '@jumbo/Dashboards/Media/FileUploader';
import TestSelectOption from '../compnents/TestSelectOption';
import TestTitle from '../compnents/TestTitle';
import ImagePicker from '../compnents/ImagePicker';
import TestImageElement from '../compnents/TestImageElement';

const useStyles = makeStyles(theme => ({
  cardContainer: {
    marginTop: 10,
  },
  answerSelctText: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

const TestImageQuestionElement = ({
  questoinTitle,
  setQuestoinTitle,
  cover,
  setCover,
  score,
  setScore,
  correctOption,
  setCorrectOption,
  firstOption,
  setfirstOption,
  secondOption,
  setSecondOption,
  thirdOption,
  setThirdOption,
  forthOption,
  setForthOption,
}) => {
  const classes = useStyles();
  const [openFileUploader, setOpenFileUploader] = useState(false);

  return (
    <React.Fragment>
      <TestTitle value={questoinTitle} handeChange={value => setQuestoinTitle(value)} />
      <Grid item xs={12}>
        <Typography className={classes.answerSelctText}>انتخاب تصویر سوال</Typography>
        <ImagePicker
          cover={cover}
          handlePick={() => setOpenFileUploader(true)}
          previewStyles={{ marginInline: 'auto', marginBlock: '20px' }}
          placeHolderStyles={{ marginInline: 'auto', marginBlock: '20px' }}
          handleRevome={() => setCover('')}
        />
      </Grid>
      <TestImageElement text={'الف'} value={firstOption} handleChange={value => setfirstOption(value)} />
      <TestImageElement text={'ب'} value={secondOption} handleChange={value => setSecondOption(value)} />
      <TestImageElement text={'ج'} value={thirdOption} handleChange={value => setThirdOption(value)} />
      <TestImageElement text={'د'} value={forthOption} handleChange={value => setForthOption(value)} />
      <TestSelectOption
        title={'گزینه صحیح'}
        value={correctOption}
        handleChange={value => setCorrectOption(value)}
        options={[
          { optName: 'الف', value: 'optionA' },
          { optName: 'ب', value: 'optionB' },
          { optName: 'ج', value: 'optionC' },
          { optName: 'د', value: 'optionD' },
        ]}
      />
      <TestOption text={''} title={'پله'} type={'number'} value={score} handleChange={value => setScore(+value)} />
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={selected => setCover(selected)}
        selectedItem={cover}
        imageSelector={true}
      />
    </React.Fragment>
  );
};

export default TestImageQuestionElement;
